import React from 'react';
import { CprIcon } from 'canopy-styleguide!sofe';
import { useNav } from 'src/nav.context';
import styles from './nav-items.styles.css';
import { TimeIcon } from './time-icon.component';

export const NavItem = ({ navItem }) => {
  const nav = useNav();

  const navIcon = ({ id, icon, label, component, secondary }) => (
    <div
      className={styles.navIcon}
      style={{ height: label ? 60 : '' }}
      onClick={() => {
        nav.setSecondaryOpen(
          secondary && (!nav.secondaryOpen || id !== nav.secondaryOpen.id) ? { id, secondary } : null
        );
      }}>
      {icon ? (
        <>
          <CprIcon name={icon} />
          <span className={styles.navLabel}>{label}</span>
        </>
      ) : component ? (
        id === 'time' ? (
          <TimeIcon />
        ) : (
          component()
        )
      ) : null}
    </div>
  );

  return navItem.enabled ? (
    <li
      className={`${styles.navItem} ${nav.isActive(navItem.matches) ? styles.active : ''} ${
        nav.isSelected(navItem.id) ? styles.selected : ''
      }`}>
      {navItem.url ? (
        <a href={`/#/${navItem.url}`} className={styles.navLink}>
          {navIcon(navItem)}
        </a>
      ) : navItem.icon || navItem.component ? (
        navIcon(navItem)
      ) : null}
    </li>
  ) : null;
};
